var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 18.825C13.2569 18.9419 12.6291 19.0005 12 19C7.522 19 3.732 16.057 2.457 12C2.80027 10.9081 3.32899 9.88346 4.02 8.971M9.878 9.879C10.4407 9.31634 11.2038 9.00025 11.9995 9.00025C12.7952 9.00025 13.5583 9.31634 14.121 9.879C14.6837 10.4417 14.9998 11.2048 14.9998 12.0005C14.9998 12.7962 14.6837 13.5593 14.121 14.122M9.878 9.879L14.121 14.122M9.878 9.879L14.12 14.12M14.121 14.122L17.412 17.412M9.88 9.88L6.59 6.59M6.59 6.59L3 3M6.59 6.59C8.20236 5.54957 10.0811 4.9974 12 5C16.478 5 20.268 7.943 21.543 12C20.839 14.2305 19.3774 16.1446 17.411 17.411M6.59 6.59L17.411 17.411M17.411 17.411L21 21",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hidePassword.2480d1aecf3901a4324da40c181ddecd.svg";
export { ForwardRef as ReactComponent };